import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SignInComponent } from '../components/authentication/sign-in/sign-in.component';
import { SignUpCustomerTypeSelectionComponent } from '../components/authentication/sign-up-customer-type-selection/sign-up-customer-type-selection.component';
import { ResetPasswordComponent } from '../components/authentication/reset-password/reset-password.component';
import { ModalDialogImageComponent } from '../../shared/components/modal-dialog-image/modal-dialog-image.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  readonly dialog = inject(MatDialog);
  private router = inject(Router);
  translateService = inject(TranslateService);

  openSignInDialog(): void {
    this.closeAllDialog();
    this.dialog.open(SignInComponent, {
      data: null,
    });
    this.router.navigateByUrl('/');

  }

  openResetPasswordDialog(): void {
    this.closeAllDialog();
    this.dialog.open(ResetPasswordComponent, {
      data: null,
    });
  }

  openSignUpCustomerTypeSelectionDialog() {
    this.closeAllDialog();
    this.dialog.open(SignUpCustomerTypeSelectionComponent, {
      data: null,
    });
  }

  openCustomerTypeImageDialog() {
    const imageUrl = '/assets/customer_type_selection.png';

    // this.closeAllDialog();
    this.dialog.open(ModalDialogImageComponent, {
      data: {
        type: 'image',
        imageUrl,
      },

    })
  }

  openCustomerTypeTextDialog() {
    this.dialog.open(ModalDialogImageComponent, {
      data: {
        type: 'text',
        value: this.translateService.instant('common.enterYourCompanyNameExactlyAsIt'),
        fontSize: '16px'
      }
    })
  }

  closeAllDialog(): void {
    this.dialog.closeAll();
  }
 openFileUploadRestrictionDialog() {
    this.dialog.open(ModalDialogImageComponent, {
      data: {
        type: 'text',
        value: this.translateService.instant('common.fileUploadRestrictions'),
        fontSize: '16px',
      }
    })
  }
}
